/*
 * The map of an event. The front-end manifest, see lib/docs/extensions/writing-an-extension.md.
 */
import { defineExtension } from '@lib/extensions/define';

import de from './locale/de';
import en from './locale/en';

export default defineExtension({
	name: 'map',
	locale: { de, en },
	slots: {
		// The layers and markers of an event, for its admins: events.read app wide or event.write on it
		'context.settings': [
			{
				id: 'map',
				icon: 'fa-map',
				group: 'map',
				contexts: ['event'],
				contextPermission: ['event.write', 'events.read'],
				order: 50,
				component: () => import('./pages/Map.vue'),
				props: ({ record }) => ({ event: record }),
			},
			{
				id: 'markers',
				icon: 'fa-map-pin',
				group: 'map',
				contexts: ['event'],
				contextPermission: ['event.write', 'events.read'],
				order: 60,
				component: () => import('./pages/Marker.vue'),
				props: ({ record }) => ({ event: record }),
			},
		],
	},
});
